module.exports = __webpack_public_path__ + "img/calendar-31_fill.91e67397.svg";